export const obavijest_smjestaj= {
    templateId: 238.2,
    category: 4,
    templateTitle: 'Troškovi smještaja radnika - Obavijest radnika poslodavcu o prestanku izdataka za troškove smještaja',
    templateDescription: `<p>Radnik kojemu poslodavac isplaćuje naknadu troškova za samostalno ugovoren smještaj od strane radnika, dužan je odmah obavijestiti poslodavca da više nema izdataka za takav smještaj.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Troškovi smještaja radnika nastali za vrijeme radnog odnosa kod poslodavaca mogu  biti neoporezivo podmireni radniku, do visine stvarnih izdataka, pri čemu se neoporezivi primitak priznaje za mjesec u kojem je usluga smještaja obavljena.</p>
    <p>Trošak smještaja radnika može biti podmiren:</p>
    <li>na način da poslodavac  s trećima ugovori pružanje usluga smještaja za radnika, ili </li>
    <li>organizacijom smještaja radnika kod samog poslodavca, ili</li>
    <li><strong>na način da radnik sam sklopi ugovor o najmu s pružateljem usluge ili nađe smještaj,  pri čemu se radniku isplaćuje naknada troškova smještaja na račun radnika, a o čemu poslodavac donosi odluku o isplati naknade koju možete pogledati <a class="local-link" href="/contract?template=238">ovdje</a>.</strong></li>
    <br>
    <p><strong>U slučaju da radnik više nema izdataka za smještaj, obavezan je o istom obavijestiti poslodavca, a prema primjerku navedene obavijesti u nastavku.</strong></p>
    <p>Ukoliko radnik ima dva ili više poslodavaca, predlaže se da svakomjesečno izjavljuje poslodavcu koji isplaćuje naknadu troškova smještaja da nije ostvario pravo na naknadu troškova kod drugog poslodavca, a prema primjeru koji se nalazi <a class="local-link" href="/contract?template=238.1">ovdje</a>.</p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o porezu na dohodak, Pravilnik o porezu na dohodak.</p>
  `,
  sides: [
    {
      signature: "Radnik:",
      inputs:[{ 
        type: "input", 
        required: true, 
        placeholder: "Ime i prezime",
        label: "Ime i prezime",
        inSignature: true,
      },
      { 
        type: "input", 
        required: true, 
        placeholder: "Ulica i kućni broj",
      },
      { 
        type: "input", 
        required: true, 
        placeholder: "Mjesto",
      },
      { 
        type: "input", 
        required: true, 
        placeholder: "OIB",
      },
      ],
      suffix: " (u daljnjem tekstu: Radnik),"
    }
    ],
      
    headline: "dajem sljedeću",
    title: "OBAVIJEST",
  
    noArticleNumbers: true,
  
    articles: [
    {
      title: "",
      dummy: "true",
      mandatory: false,
      statements: [
      {
        type: "input",
        mandatory: true,
        editable: false,
        parts: [
          { type: "text", content: "kojom ja, gore navedeni, u vezi s pravom na naknadu troškova smještaja koje ostvarujem kod poslodavca, obavještavam poslodavca" },
          { type: "input",  required: true, placeholder: "Unesite naziv poslodavca" },
          { type: "text", content: "," },
          { type: "input",  required: true, placeholder: "Unesite adresu poslodavca" },
          { type: "text", content: ", OIB:" },
          { type: "input",  required: true, placeholder: "Unesite OIB poslodavca" },
          { type: "text", content: ", da počevši od" },
          { type: "input",  required: true, placeholder: "Unesite datum." },
          { type: "text", content: "nemam izdataka za samostalno pronađen i ugovoren smještaj, a za koji mi je temeljem odluke poslodavca do sada isplaćivana naknada troškova smještaja." },
        ],
        value:"",
      }]
    },
    {
      mandatory: true,
      static: true,
      type: 2, // date and place
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
            {
              type: "text",
              content: "U"
            },
            {
              type: "input",
              value: "",
              placeholder: "Upišite mjesto.",
              required: true,
            },
            {
              type: "text",
              content: ", dana"
            },
            {
              type: "date",
              value: new Date(),
              required: true
            },
            {
              type: "text",
              content: "godine."
            }
          ]
        },
      ]
    },
    {
      mandatory: true,
      static: true,
      type: 3,  // signatures   
      statements: [],
    },
    {
      static: true,
      mandatory: true,
      editable: true,
      type: 4, 
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          content: "\r\n\r\nPoslodavac svojim potpisom potvrđuje primitak ove Obavijesti dana ________________ godine.\r\n\r\nZa Poslodavca: ________________________. "
          },
        ],
      },
  ],
  };


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/238.2._obavijest_smjestaj.ts